<template>
  <div class="uploadPicture">
    <div v-if="upDataValue">
      <div class="uploadBut2" v-if="disabled && imgList.length < length" v-loading.body="isLoading">
        <input type="file" @change="filechange($event)" />
        <span v-if="!isLoading">{{upDataValue}}</span>
        <div class="sizeValue" v-if="sizeValue">{{sizeValue}}</div>
      </div>
      <div>
        <div class="imgBox" v-for="(item,index) of imgList" :key="index">
          <div class="imgList">
            <video v-if="item.photoType === 2" :src="item.photoUrl || item.fragmentUrl"></video>
            <img
              v-else
              :src="item.userFileUrl || item.photoUrl||item.companyUserFileUrl||item.bannerFileUrl"
              :id="item.userFileUrl"
            />
            <div class="mask">
              <i class="el-icon-view" @click="preview(item,index)"></i>
              <i class="el-icon-delete" v-if="disabled" @click="deletes(index)"></i>
            </div>
            <i></i>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="imgBox" v-for="(item,index) of imgList" :key="index">
        <div class="imgList">
          <video v-if="item.photoType === 2" :src="item.photoUrl || item.fragmentUrl"></video>
          <img
            v-else
            :src="item.userFileUrl || item.photoUrl||item.companyUserFileUrl||item.bannerFileUrl"
            :id="item.userFileUrl"
          />
          <div class="mask">
            <i class="el-icon-view" @click="preview(item,index)"></i>
            <i class="el-icon-delete" v-if="disabled" @click="deletes(index)"></i>
          </div>
          <i></i>
        </div>
         <div style="color: #606266;" v-if="lableName&&item.labelName">{{item.labelName}}</div>
      </div>

      <div class="uploadBut" v-if="disabled && imgList.length < length" v-loading.body="isLoading">
        <input type="file" @change="filechange($event)" />
        <span v-if="!isLoading">+</span>
      </div>
    </div>

    <!--//预览图片-->
    <el-dialog :visible.sync="dialogVisible" :width="previewImgWidth+'%'">
      <!-- <img
        v-if="dialog.userFileType ===1||dialog.photoType==1"
        width="100%"
        :src="dialog.userFileUrl || dialog.photoUrl"
      />-->

      <video
        v-if="dialog.photoType === 2"
        width="100%"
        controls="controls"
        :src="dialog.photoUrl || dialog.fragmentUrl"
      ></video>
      <!-- <div
        style=" font-size: 30px;position: fixed;top: 20px;right: 40px;text-align:center;color: #ffffff;"
      >
        <i @click="addWidth" style="margin-right:15px;cursor: pointer;" class="el-icon-zoom-in"></i>
        <i @click="jianWidth" style="cursor: pointer;" class="el-icon-zoom-out"></i>
      </div>-->
    </el-dialog>
    <div v-if="imageViewerVisible">
      <el-image-viewer
        v-if="dialog.userFileType ===1||dialog.photoType==1||dialog.companyUserFileUrl"
        :on-close="closeViewer"
        :url-list="previewUrlList"
      />
    </div>
  </div>
</template>
<script>
import { async } from "@/config/fetch";
import Viewer from "viewerjs";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  components: { ElImageViewer },

  props: {
    upDataValue: {
      default: function () {
        return "";
      },
    },
    sizeValue: {
      default: function () {
        return "";
      },
    },
    value: {
      default: function () {
        return "";
      },
    },
    disabled: {
      default: function () {
        return true;
      },
    },
    length: {
      default: function () {
        return 7;
      },
    },
    showtime: {
      default: function () {
        return false; // 是否显示图片创建时间
      },
    },
    type: {
      default: function () {
        return 1; //0 可传图片和视频 1只能传图片  2只能传视频
      },
    },
    fileType: {
      default: function () {
        return "内容"; //
      },
    },
    lableName:{
       default: function () {
        return false; // 是否显示证书图片类型
      },
    }
  },
  data () {
    return {
      imageViewerVisible: false,
      previewUrlList: [],
      previewImgWidth: 30,
      imgList: [],
      isLoading: false,
      dialogVisible: false,
      dialog: {},
      valueName: "",
      viewer: null,
      aa: [],
    };
  },
  computed: {},
  methods: {
    addWidth () {
      if (this.previewImgWidth < 100) {
        this.previewImgWidth += 5;
      }
    },
    jianWidth () {
      if (this.previewImgWidth > 20) {
        this.previewImgWidth -= 5;
      }
    },
    aaa (item) {
      console.log(item);
      // View an image

      this.aa.push(item.userFileUrl);
      this.viewer = new Viewer(document.getElementById(item.userFileUrl), {
        url: this.aa,
      });
      this.viewer.show();

      // View a list of images
    },
    //删除
    deletes (index) {
      if (this.fileType == "banner") {
        this.$confirm("确定要删除该banner？", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((res) => {
            this.imgList.splice(index, 1);
            this.$emit("upload", this.imgList);
          })
          .catch((action) => {
            return;
          });
      } else {
        this.imgList.splice(index, 1);
        this.$emit("upload", this.imgList);
      }
    },
    //查看
    preview (data, index) {
      console.log(data);
      if (data.photoType === 2) {
        this.dialog = data;
        this.dialogVisible = true;
      }
      if (
        data.userFileType === 1 ||
        data.photoType == 1 ||
        data.companyUserFileType == 1
      ) {
        this.previewUrlList = [];
        this.imgList.forEach((obj, i) => {
          if (i == index) {
            if (obj.userFileUrl) {
              this.previewUrlList.unshift(obj.userFileUrl);
            }
            if (obj.photoUrl) {
              this.previewUrlList.unshift(obj.photoUrl);
            }
            if (obj.companyUserFileUrl) {
              this.previewUrlList.unshift(obj.companyUserFileUrl);
            }
          } else {
            if (obj.userFileUrl) {
              this.previewUrlList.push(obj.userFileUrl);
            }
            if (obj.photoUrl) {
              this.previewUrlList.push(obj.photoUrl);
            }
            if (obj.companyUserFileUrl) {
              this.previewUrlList.push(obj.companyUserFileUrl);
            }
          }
        });

        this.dialog = data;
        this.imageViewerVisible = true;
      }
    },
    closeViewer () {
      this.imageViewerVisible = false;
    },
    //
    fileAjax (files, state) {
      const _this = this;
      if (typeof FileReader === "undefined") {
        this.$notify.error({
          title: "错误",
          message: "抱歉，你的浏览器不支持 FileReader",
        });
      } else {
        this.isLoading = true;
        var data = new FormData();
        data.append("files", files);
        data.append("valueName", this.fileType);
        var fileUrl = "/uplodController/uploadFileOss.do";
        // if (this.type == 1) {
        //   fileUrl = "/commodityController/uploadCommodityBanner.do";
        // }
        async(fileUrl, data, "FORM", {
          contentType: "",
        })
          .then((data) => {
            var red = data.data[0];
            _this.isLoading = false;
            _this.$notify({
              title: "成功",
              message: "上传成功",
              type: "success",
            });
            console.log(red);
            console.log(state);
            if (state === 1) {
              if (_this.type == 1) {
                _this.imgList.push({
                  photoUrlHeight: red.photoUrlHeight,
                  photoUrlWidth: red.photoUrlWidth,
                  photoUrl: red.photoUrl,
                  photoType: 1,
                });
              } else {
                _this.imgList.push({
                  userFileUrl: red.userFileUrl,
                  width: red.width,
                  height: red.height,
                  photoUrlHigh: red.photoUrlHigh,
                  photoUrlWide: red.photoUrlWide,
                  photoUrl: red.photoUrl,
                  photoType: 1,
                  userFileType: 1,
                });
              }
            } else {
              _this.imgList.push({
                photoUrlWide: red.photoUrlWide,
                photoUrl: red.photoUrl,
                photoUrlCover: red.photoUrlCover,
                photoUrlHigh: red.photoUrlHigh,
                voiceLength: red.voiceLength,
                photoType: 2,
              });
            }
            console.log(JSON.parse(JSON.stringify(_this.imgList)));
            _this.$emit("input", _this.imgList);
          })
          .catch(function (err) {
            console.log(err);
            _this.isLoading = false;
            _this.$notify.error({
              title: "错误",
              message: "上传失败",
            });
          });
      }
    },
    //上传图片
    filechange (e) {
      const _this = this;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return false;
      }
      // const patnImg = /\.jpg$|\.jpeg$|\.png$|\.gif$/;
      const patnImg = /\.jpg$|\.JPG$|\.jpeg$|\.png$|\.gif$/;

      if (this.type == 1) {
        if (patnImg.test(files[0].name)) {
          this.fileAjax(files[0], 1);
        } else {
          _this.$notify.error({
            title: "错误",
            message: "只能上传jpg、jpeg、png、gif格式图片",
          });
        }
      } else if (this.type == 2) {
        if (/\.mp4$|\.mpeg$|\.3gp$/.test(files[0].name)) {
          this.fileAjax(files[0], 2);
        } else {
          _this.$notify.error({
            title: "错误",
            message: "只能上传mp4、mpeg、3gp格式视频",
          });
        }
      } else {
        if (patnImg.test(files[0].name)) {
          this.fileAjax(files[0], 1);
        } else if (/\.mp4$|\.mpeg$|\.3gp$/.test(files[0].name)) {
          this.fileAjax(files[0], 2);
        } else {
          _this.$notify.error({
            title: "错误",
            message:
              "只能上传jpg、jpeg、png、gif格式图片或mp4、mpeg、3gp格式视频",
          });
        }
      }
    },
  },
  watch: {
    value (val) {
      if (val instanceof Array) {
        this.imgList = val;
      } else {
        if (val) {
          this.imgList = val.split(",");
        }
      }
    },
  },
  mounted () {
    if (this.value instanceof Array) {
      this.imgList = this.value;
    } else {
      if (this.value) {
        this.imgList = this.value.split(",");
      }
    }
  },
};
</script>
<style scoped lang="scss">
.uploadPicture {
  // display: flex;
  // overflow-y: scroll;
  .uploadBut {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 120px;
    height: 120px;
    cursor: pointer;
    line-height: 120px;
    vertical-align: top;
    font-size: 60px;
    text-align: center;
    color: #999;
    margin: 5px 15px 5px 0;
    position: relative;
    input {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
  .uploadBut2 {
    width: 73px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    font-size: 12px;
    color: #00a14d;
    font-weight: bold;
    border-radius: 4px;
    border: 1px solid rgba(0, 161, 77, 1);
    position: relative;
    top: 7.5px;
    margin-bottom: 20px;

    input {
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      font-size: 0;
    }
    .sizeValue {
      position: absolute;
      left: 110%;
      top: 0px;
      white-space: nowrap;
      color: #909090;
    }
  }
  .imgBox {
    margin-right: 20px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    float: left;
    .imgTime {
      width: 100%;
      line-height: 22px;
      font-size: 12px;
      padding-bottom: 10px;
    }
    .imgList {
      background-color: #fbfdff;
      border-radius: 6px;
      box-sizing: border-box;
      width: 120px;
      height: 120px;
      cursor: pointer;
      line-height: 120px;
      vertical-align: top;
      overflow: hidden;
      position: relative;
      margin: 5px 0;
      box-shadow: 0px 1px 2px 2px #dfdfdf;
      img {
        position: absolute;
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
      }
      video {
        width: 120px;
        height: 120px;
      }
      .isDelete {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 120px;
        background-color: rgba(51, 51, 51, 0.5);
        color: rgba(255, 255, 255, 0.8);
        font-size: 16px;
        line-height: 120px;
        text-align: center;
      }
      .mask {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        opacity: 0;
        border-radius: 6px;
        transition: all 0.5s;
        text-align: center;

        i {
          color: #fff;
          margin: 0px 5px;
          font-size: 20px;
        }
      }
    }
    .imgList:hover {
      .mask {
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue